import axios from 'axios'

const getQEMISpri = ({ commit, state }, payload) => {
  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងរក្សាទិនន្ន័យទៅម៉ាសុីនមេ...' }, { root: true })
  const config = {
    params: {
      acc_code: payload.acc_code,
      sch_code: payload.sch_code
    }
  }

  axios.get('/qemis/pri', config)
    .then((response) => {
      commit('LOAD_DATA_QEMIS_PRI', response.data)
      commit('uiControl/RSTATE_SUCCESS', null, { root: true })
      commit('uiControl/TAB_STATE_CHANGE', { sTab: 3, vTab: 0 }, { root: true })
      //add below code for disable/enable save button      
      commit('uiControl/SET_SCHOOL_STATE', response.data.state_code.sta_code, { root: true })
      if (state.school_dt.res === '0') {
        commit('uiControl/RSTATE_ERRORS', { errMessage: 'ពុំមានសាលានេះទេ!' }, { root: true })
      }
    }, (error) => {
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
      //console.log(error)
    })
}

const loadDefaultQEMISpri = ({ commit, state }) => {
  commit('LOAD_DEFAULT_QEMIS_PRI')
}

const searchQEMISpri = ({ commit, state }, payload) => {

}

const saveQEMISpri = ({ commit, state }, payload) => {
  // var d = JSON.parse(JSON.stringify(state.school_dt))
  var d = state.school_dt
  let sId = d.state_code.sta_id
  let sCode = 33 // 32 entry & Invalid, 33 entry & valided, 35 entry and closed ====> UPGRADE IN FUTURE
  // qemis G1
  let priDt = '('
  for (let i = 0; i < d.sco_g1.length; i++) {
    priDt += d.sco_g1[i].id + ',' + d.sco_g1[i].dt_g + ',' + d.sco_g1[i].dt_b + '),('
  }
  // qemis G2
  for (let i = 0; i < d.sco_g2.length; i++) {
    priDt += d.sco_g2[i].id + ',' + d.sco_g2[i].dt_g + ',' + d.sco_g2[i].dt_b + '),('
  }
  // qemis G3
  for (let i = 0; i < d.sco_g3.length; i++) {
    priDt += d.sco_g3[i].id + ',' + d.sco_g3[i].dt_g + ',' + d.sco_g3[i].dt_b + '),('
  }
  // qemis G4
  for (let i = 0; i < d.sco_g4.length; i++) {
    priDt += d.sco_g4[i].id + ',' + d.sco_g4[i].dt_g + ',' + d.sco_g4[i].dt_b + '),('
  }
  // qemis G5
  for (let i = 0; i < d.sco_g5.length; i++) {
    priDt += d.sco_g5[i].id + ',' + d.sco_g5[i].dt_g + ',' + d.sco_g5[i].dt_b + '),('
  }
  // qemis G6
  for (let i = 0; i < d.sco_g6.length; i++) {
    priDt += d.sco_g6[i].id + ',' + d.sco_g6[i].dt_g + ',' + d.sco_g6[i].dt_b + '),('
  }
  priDt = priDt.slice(0, -2)
  // console.log(priDt)
  // posting to server
  commit('uiControl/RSTATE_LOADING', { message: 'កំពុងរក្សាទិនន្ន័យទៅម៉ាសុីនមេ...' }, { root: true })
  axios.post('/qemis/pri', { sta_id: sId, priDt: priDt, state_code: sCode })
    .then((response) => {
      // console.log(response.data + 'Done')
      if (response.data === 0) {
        commit('uiControl/RSTATE_SAVE_SUCCESS', { message: 'ទិនន្ន័យរក្សាទុកត្រឹមត្រូវក្នុងម៉ាសុីនមេ' }, { root: true })
      } else {
        commit('uiControl/RSTATE_ERRORS', { errMessage: 'ការរក្សាទុកទិន្នន័យមានបញ្ហា! មូលហេតុ៖ ' + response.data }, { root: true })
      }
    }, (error) => {
      // console.log(error)
      commit('uiControl/RSTATE_ERRORS', { errMessage: error }, { root: true })
    })
}

const logQEMISpri = ({ commit, state }) => {
  // console.log(state.school_dt.sco_g1[0].dt)
}
// Secondary school data sessions
const getQEMISSec = ({ commit, state }, payload) => {
}

const saveQEMISSec = ({ commit, state }, payload) => {
}

export {
  loadDefaultQEMISpri,
  searchQEMISpri,
  getQEMISpri,
  saveQEMISpri,
  logQEMISpri,
  getQEMISSec,
  saveQEMISSec
}
